import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'
import TreasuryAccountsPage from './TreasuryAccountsPage.vue'

export const treasuryAccountsRoutes: RouteRecordRaw[] = [
  {
    path: routes.TREASURY_ACCOUNTS_DIRECTORY,
    name: 'treasury.treasuryAccounts',
    component: TreasuryAccountsPage,
    meta: {
      layout: 'admin',
      requiresAuth: true,
      title: 'Treasury accounts',
      activeMenu: 'Treasury',
    },
  },
]
